/**
 * src/api/prospeccion.js
 * Prospección del universo de proveedores del CM (módulo de inteligencia
 * comercial). Auth por JWT Bearer del usuario admin, como el resto del panel.
 */
import api from './client'

export const getProspeccionStatus = () =>
  api.get('/admin/prospeccion/status').then(r => r.data)

export const getProspeccionLeads = ({ estado = '', limit = 50, offset = 0 } = {}) =>
  api.get('/admin/prospeccion/leads', { params: { estado, limit, offset } }).then(r => r.data)

export const ejecutarProspeccion = ({ maxRequests = 8000, background = true } = {}) =>
  api.post('/admin/prospeccion/ejecutar', null, {
    params: { max_requests: maxRequests, background },
    // Un run inline puede tardar bastante más que el timeout por defecto (30 s).
    timeout: background ? 30_000 : 600_000,
  }).then(r => r.data)

export const importarProspeccion = (payload) =>
  api.post('/admin/prospeccion/importar', payload).then(r => r.data)

/**
 * Descarga el CSV. No se puede usar un <a href> directo: el endpoint exige el
 * Bearer y el navegador no lo adjuntaría — se pide como blob y se dispara la
 * descarga en cliente.
 */
async function descargarBlob(ruta, nombre, tipo) {
  const r = await api.get(ruta, { responseType: 'blob' })
  const url = URL.createObjectURL(new Blob([r.data], { type: tipo }))
  const a = document.createElement('a')
  a.href = url
  a.download = nombre
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export const descargarProspeccionCsv = () =>
  descargarBlob('/admin/prospeccion/export', 'prospeccion_leads.csv',
                'text/csv;charset=utf-8')

/** Libro Excel nativo con las 4 hojas del modelo. */
export const descargarProspeccionXlsx = () =>
  descargarBlob('/admin/prospeccion/export.xlsx', 'CM_Monitor_BBDD_Prospeccion.xlsx',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
